import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useState, useRef } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Popover from '@mui/material/Popover';
import dayjs from 'dayjs';
import debounce from 'lodash.debounce';
import DatePickerField from "../../common/DatePickerDashboard";
import { TableSortLabel } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Stack,
  Pagination,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  TableContainer,
  Paper,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  exportRaterReportAction,
  getRaterReportAction} from "../../redux/actions/reportActions";
import { searchAgentAction } from "../../redux/actions/userActions";
import {
  getAllLocationsAction,
} from "../../redux/actions/agencyActions";
import { emailValidation } from "../../common/helpers/validation";
import NoDataFound from "../../common/NoDataFound";
import NoSearchResults from "../../common/helpers/NoSearchResults";
import PhoneNumberField from "../../common/PhoneNumberField";


const formatPhoneForDisplay = (phone) => {
  if (!phone) return '';


  const cleaned = ('' + phone).replace(/\D/g, '');


  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return phone;
};

const RaterReport = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const [hasSearched, setHasSearched] = useState(false);

  const [isFiltered, setIsFiltered] = useState(false);
  const [agentSearchTerm, setAgentSearchTerm] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [resetCount, setResetCount] = useState(0);
  const [showColumnToggle, setShowColumnToggle] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const handleDownloadClick = (event) => setDownloadAnchorEl(event.currentTarget);
  const handleDownloadClose = () => setDownloadAnchorEl(null);
  const [searchError, setSearchError] = useState('');
  const [appliedFilters, setAppliedFilters] = useState({});
  const columnToggleRef = useRef(null);

  const defaultColumns = {
    name: true,
    id: true,
    address: true,
    source: true,
    lastModified: true,
    gethomeOwner: true,
    occupation: true,
    zipCode: true,
    city: true,
    email: true,
    phoneNumber: true,
    quoteNumber: true,
    officeLocation: true,
    boundStatus: true,
    quoteDescription: true,
    agentName: true,
  };

  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);

  const handleSort = (field) => {
    const isAsc = sortField === field && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortField(field);
  };

  const initialFilters = {
    agentName: '',
    lastModified: '',
    officeLocation: '',
    createdDate: '',
    name: '',
    phoneNumber: '',
    email: '',
    address: '',
    zipCode: '',
    city: '',
    quoteDescription: '',
    occupation: '',
    homeOwner: '',
    source: '',
    updatedDate: '',
    updatedBy: '',
    boundStatus: '',
    fromDate: '',
    toDate: '',
  };

  const [filters, setFilters] = useState(initialFilters);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState({});

  const production_report_data = useSelector(
    (state) => state.allReportReducer.raterReportData.content || []
  );
  const production_report_pagination = useSelector(
    (state) => state.allReportReducer.raterReportData || {}
  );
  const search_agent_list = useSelector(
    (state) => state.user.search_agent || {}
  );
  const get_all_location = useSelector(
    (state) => state?.agency?.get_all_locations_list || []);

  const agentOptions = search_agent_list.content || [];

  const handleAgentSearch = debounce((value) => {
    if (value?.length > 1) {
      dispatch(searchAgentAction(value));
    }
  }, 300);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };


const formatPhoneNumber = (phone) => {
  if (!phone) return '';


  const cleaned = ('' + phone).replace(/\D/g, '');


  if (cleaned.length === 10) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  }


  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    const without1 = cleaned.substring(1);
    return `${without1.substring(0, 3)}-${without1.substring(3, 6)}-${without1.substring(6)}`;
  }

  return phone;
};


const removePlusOne = (phone) => {
  if (!phone) return '';

  const cleaned = ('' + phone).replace(/\D/g, '');

  const normalized = cleaned.length === 11 && cleaned.startsWith('1')
    ? cleaned.substring(1)
    : cleaned;

  if (normalized.length === 10) {
    return `${normalized.substring(0, 3)}-${normalized.substring(3, 6)}-${normalized.substring(6)}`;
  }

  return phone;
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (columnToggleRef.current && !columnToggleRef.current.contains(event.target)) {
      setShowColumnToggle(false);
    }
  };

  if (showColumnToggle) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showColumnToggle]);

  useEffect(() => {
    dispatch(getAllLocationsAction());
  }, [dispatch]);
  const open = Boolean(anchorEl);
  const popoverId = open ? 'filter-popover' : undefined;

  const handleDownloadCSV = async() => {
    await dispatch(exportRaterReportAction(appliedFilters, "csv"));
  };

  const handleDownloadExcel = async() => {
   await dispatch(exportRaterReportAction(appliedFilters, "xlsx"));
  };

  const handleDownloadPDF = async() => {
  await dispatch(exportRaterReportAction(appliedFilters, "pdf"));
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (page > 0 && paginationData.totalPages > 0 && page >= paginationData.totalPages) {
      setPage(0);
    }
  }, [paginationData.totalPages]);

  useEffect(() => {
    if (isFiltered) {
      dispatch(getRaterReportAction(appliedFilters, page, rowsPerPage, sortField, sortOrder));
    }
  }, [page, rowsPerPage, sortField, sortOrder, isFiltered, appliedFilters]);

const handleSubmit = () => {
   setTableData([]);
      setPaginationData({});
  const hasAnyFilter = Object.values(filters).some(
    value => value !== '' && value !== null && value !== undefined
  )

  if (!hasAnyFilter) {
    setSearchError('Please fill at least one search field.');
    return;
  }

  if (filters.email && !emailValidation(filters.email)) {
    setSearchError('Please enter a valid email address.');
    return;
  }

  setSearchError('');
  setHasSearched(true);

  const cleanedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {

      if (key === 'phoneNumber') {
        acc[key] = `+1${value}`;
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {});

  setIsFiltered(true);
  setAppliedFilters(cleanedFilters);
  setPage(0);
};

  const handleReset = () => {
    setFilters(initialFilters);
    setAppliedFilters({});
    setIsFiltered(false);
    setHasSearched(false);
    setTableData([]);
    setPaginationData({});
    setFieldErrors({});
    setTouchedFields({});
    setPage(0);
    setSearchError('');
    setResetCount(prev => prev + 1);
     dispatch({ type: "RESET_RATER_REPORT", payload: [] });
  };

  useEffect(() => {
    if (isFiltered && production_report_data.length > 0) {
      setTableData(production_report_data);
      setPaginationData(production_report_pagination);
    }
  }, [production_report_data, production_report_pagination, isFiltered]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const saved = localStorage.getItem('visible_columns');
    if (saved) {
      setVisibleColumns(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const columnCount = Object.values(visibleColumns).filter(Boolean).length;

  return (
    <Box sx={{
      width: "96%",
      margin: "0 auto",
      padding: isMobile ? '8px' : isTablet ? '12px' : '16px',
       minHeight: '90vh',
        '@media (min-width: 768px) and (max-width: 1024px)': {
            minHeight: '60vh',
            height: 'auto',
            overflowY: 'auto',
          },
          '@media (min-width: 1024px) and (min-height: 1366px)': {
            height: 'auto',
            minHeight: '83vh',
          },

    }}>
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 2,
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? 1 : 0
      }}>
       <Typography 
       variant={isMobile ? "h6" : "h2"} 
       sx={{marginTop: '20px' }}>
    Report: Rater Report {hasSearched && `(${paginationData.totalElements || 0})`}
</Typography>
        <Box sx={{
          display: 'flex',
          margin: isMobile ? '8px 0' : isTablet ? '12px 0 5px 0' : '15px 0 5px 0',
          marginTop: '0px',

          alignItems: 'center',
          gap: 1,
          mb: isMobile ? 1 : 2,
          flexWrap: 'wrap',
          justifyContent: isMobile ? 'flex-start' : 'flex-end'

        }}>
         <Button
          variant="outlined"
          onClick={handleDownloadClick}
          endIcon={<MoreVertIcon />}
          disabled={!isFiltered || tableData.length === 0}
        >
          Download
        </Button>

          <Menu
            anchorEl={downloadAnchorEl}
            open={Boolean(downloadAnchorEl)}
            onClose={handleDownloadClose}
          >
            <MenuItem onClick={() => { handleDownloadExcel(); handleDownloadClose(); }} disabled={!isFiltered || tableData.length === 0}>Excel</MenuItem>
            <MenuItem onClick={() => { handleDownloadCSV(); handleDownloadClose(); }} disabled={!isFiltered || tableData.length === 0}>CSV</MenuItem>
            <MenuItem onClick={() => { handleDownloadPDF(); handleDownloadClose(); }} disabled={!isFiltered || tableData.length === 0}>PDF</MenuItem>
          </Menu>

          <Button
            variant="outlined"
            aria-describedby={popoverId}
            onClick={handleFilterClick}
          >
            Filter
          </Button>

          <Button
            variant="outlined"
            onClick={() => setShowColumnToggle((prev) => !prev)}
          >
            Select Columns
          </Button>
        </Box>
      </Box>

      {showColumnToggle && (
        <Box
         ref={columnToggleRef}
          sx={{
            position: 'absolute',
            top: isMobile ? 180 : isTablet ? 160 : 200,
            right: isMobile ? 10 : isTablet ? 20 : 30,
            zIndex: 10,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: 2,
            padding: 2,
            boxShadow: 3,
            maxWidth: isMobile ? '160px' : isTablet ? '180px' : '200px'
          }}
        >
          <Typography fontWeight={600} mb={1} fontSize={isMobile ? '14px' : isTablet ? '15px' : '16px'}>Select Columns</Typography>
          {Object.keys(defaultColumns).map((column) => (
            <FormControlLabel
              key={column}
              control={
                <Checkbox
                  checked={visibleColumns[column]}
                  onChange={() =>
                    setVisibleColumns((prev) => ({
                      ...prev,
                      [column]: !prev[column],
                    }))
                  }
                  size={isMobile ? "small" : "medium"}
                />
              }
              label={
                <Typography fontSize={isMobile ? '12px' : isTablet ? '13px' : '14px'}>
                  {column
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (str) => str.toUpperCase())}
                </Typography>
              }
            />
          ))}
        </Box>
      )}

  <Popover
    id={popoverId}
    open={open}
    anchorEl={anchorEl}
    onClose={handleFilterClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    sx={{
      '& .MuiPaper-root': {
        width: isMobile ? '95vw' : isTablet ? '90vw' : '1000px',
        maxWidth: '1000px',
        marginBottom: '100px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        margin: isMobile ? '0 auto' : 'unset',
        left: isMobile ? '2.5vw !important' : 'unset',
        right: isMobile ? '2.5vw !important' : 'unset',
        WebkitOverflowScrolling: 'touch',
      }
    }}
  >
  <Box sx={{
    p: 2,
    width: '100%',
    boxSizing: 'border-box',
    overflowY: 'auto',
    flex: 1,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '3px',
    }
  }}>
    <Grid container spacing={2}>
      {[
        { label: 'From Date', name: 'fromDate' },
        { label: 'To Date', name: 'toDate' },
        { label: 'Created Date', name: 'createdDate' },
        { label: 'Updated Date', name: 'updatedDate' },
      ].map((field) => (
        <Grid key={field.name} item xs={12} sm={6} md={3}>
          <label style={{
            fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
            fontWeight: 500,
            display: 'block',
            marginBottom: 4
          }}>
            {field.label}
          </label>
          <DatePickerField
            fieldName={field.name}
            formData={filters}
            handleDateChange={(name, value) => handleFilterChange({ target: { name, value } })}
            handleBlur={(fieldName, error) => {
              setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
              setFieldErrors((prev) => ({ ...prev, [fieldName]: error }));
            }}
            touchedFields={touchedFields}
            fieldErrors={fieldErrors}
            size={isMobile ? "small" : isTablet ? "small" : "medium"}
            sx={{
              width: '100%',
              '& .MuiInputBase-root': {
                height: isMobile ? '40px' : isTablet ? '45px' : '55px'
              }
            }}
          />
        </Grid>
      ))}

      
            <Grid item xs={12} sm={6} md={3}>
              <label style={{
                fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
                fontWeight: 500,
                display: 'block',
                marginBottom: 4
              }}>
                Office Location
              </label>
              <Autocomplete
                freeSolo
                options={get_all_location}
                getOptionLabel={(option) =>
                  typeof option === 'string'
                    ? option
                    : option.locationDescription || ''
                }
                renderOption={(props, option) => (
                  <li {...props}>
                    {option.locationDescription}
                  </li>
                )}
                onInputChange={(e, newInputValue) => {
                  setFilters((prev) => ({
                    ...prev,
                    officeLocation: newInputValue
                  }));
                }}
                size={isMobile ? "small" : isTablet ? "small" : "medium"}
                onChange={(e, newValue) => {
                  setFilters((prev) => ({
                    ...prev,
                    officeLocation: newValue?.locationDescription || newValue || ''
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Select Office Location"
                    value={filters.officeLocation}
                    sx={{
                "& .MuiOutlinedInput-root": {
                  height: {
                    xs: '36px',
                    sm: '38px',
                    md: '55px',
                    lg: '55px'
                  }
                }
              }}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  officeLocation: e.target.value
                }));
              }}
            />
          )}
        />
      </Grid>
{/* Last Modified */}
<Grid item xs={12} sm={6} md={3}>
  <label
    style={{
      fontSize: isMobile ? "12px" : isTablet ? "13px" : "14px",
      fontWeight: 500,
      display: "block",
      marginBottom: 4,
    }}
  >
    Last Modified
  </label>
  <TextField
    name="lastModified"
    type="text"
    value={filters.lastModified}
    onChange={(e) => {

      const value = e.target.value;
      setFilters({ ...filters, lastModified: value });
    }}
    placeholder="Enter last modified name"
    inputProps={{ maxLength: 15 }}
    fullWidth
    size={isMobile ? "small" : isTablet ? "small" : "medium"}
  />
</Grid>

      {/* Zip Code */}
    <Grid item xs={12} sm={6} md={3}>
  <label
    style={{
      fontSize: isMobile ? "12px" : isTablet ? "13px" : "14px",
      fontWeight: 500,
      display: "block",
      marginBottom: 4,
    }}
  >
    Zip Code
  </label>
  <TextField
    name="zipCode"
    type="text"
    value={filters.zipCode}
    onChange={(e) => {

      const value = e.target.value.replace(/\D/g, "").substring(0, 5);
      setFilters({ ...filters, zipCode: value });
    }}
    placeholder="Enter ZIP Code"
    inputProps={{ maxLength: 5 }}
    fullWidth
    size={isMobile ? "small" : isTablet ? "small" : "medium"}
  />
</Grid>


      {/* Agent Name */}
      <Grid item xs={12} sm={6} md={3}>
        <label style={{
          fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
          fontWeight: 500,
          display: 'block',
          marginBottom: 4
        }}>
          Agent Name
        </label>
        <Autocomplete
          options={agentOptions}
          value={filters.agentName || null}
          getOptionLabel={(option) =>
            typeof option === 'string'
              ? option
              : `${option.firstName || ''} ${option.lastName || ''}`
          }
          isOptionEqualToValue={(option, value) => {
            if (!value) return false;
            if (typeof value === 'string') {
              return `${option.firstName} ${option.lastName}` === value;
            }
            return option.id === value.id;
          }}
          renderOption={(props, option) => {
            const { key, ...otherProps } = props;
            // FIXED: Use a unique key combining id and names
            const uniqueKey = option.id ? `agent-${option.id}` : `agent-${option.firstName}-${option.lastName}-${Math.random().toString(36).substr(2, 9)}`;
            return (
              <li key={uniqueKey} {...otherProps}>
                {option.firstName} {option.lastName}
              </li>
            );
          }}
          onInputChange={(e, newInputValue) => {
            setAgentSearchTerm(newInputValue);
            handleAgentSearch(newInputValue);
          }}
          onChange={(e, newValue) => {
            setFilters((prev) => ({
              ...prev,
              agentName: newValue?.firstName
                ? `${newValue.firstName} ${newValue.lastName}`
                : newValue || ''
            }));
          }}
          size={isMobile ? "small" : isTablet ? "small" : "medium"}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder="Search Agent"
               sx={{
                "& .MuiOutlinedInput-root": {
                  height: {
                    xs: '36px',
                    sm: '38px',
                    md: '55px',
                    lg: '55px'
                  }
                }
              }}
            />
          )}
        />
      </Grid>

{[
  {
    label: 'Source',
    name: 'source',
    options: ['ALL', 'Walk-ins', 'Direct Mail', 'Email', 'Referrals', 'Online', 'Phone'],
  },
  {
    label: 'Home Owner',
    name: 'homeOwner',
    options: ['ALL', 'Yes', 'No'],
  },
  {
    label: 'Bound Status',
    name: 'boundStatus',
    options: ['ALL', 'BOUND', 'NOT BOUND', 'PENDING'],
  },
].map((field) => (
  <Grid key={field.name} item xs={12} sm={6} md={3}>
    <label
      style={{
        fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
        fontWeight: 500,
        display: 'block',
        marginBottom: 4,
      }}
    >
      {field.label}
    </label>
    <Autocomplete
      fullWidth
      size={isMobile ? 'small' : isTablet ? 'small' : 'medium'}
      options={field.options}
      value={filters[field.name] || null}
      isOptionEqualToValue={(option, value) => option === value}
       onChange={(e, newValue) => {
   setFilters((prev) => ({
     ...prev,
     [field.name]: newValue || ''
   }));
 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`Select ${field.label}`}
          sx={{
            '& .MuiInputBase-root': {
              height: isMobile ? '40px' : '55px',
            },
          }}
        />
      )}
    />
  </Grid>
))}


      {/* Action Buttons - Now properly visible with scroll */}
      <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ pb: 2 }}>
        <Button
          onClick={handleReset}
          variant="outlined"
          sx={{mr:2 }}
        >
          Reset
        </Button>
        <Button
          onClick={() => {
            handleSubmit();
            handleFilterClose();
          }}
          variant="contained"
        >
          Submit
        </Button>

      </Grid>
    </Grid>
  </Box>
</Popover>
       <Box mb={3} p={2} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
      <Box>
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: isMobile ? 'center' : 'start',
          gap: 2,
          alignItems: 'flex-start',
          margin: isMobile ? '8px 0' : isTablet ? '12px 0 5px 0' : '15px 0 5px 0',
          marginTop: '0px'

        }}>
          <Box sx={{ width: isMobile ? '100%' : 'auto' }}>
            <label style={{ fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px', fontWeight: 500, display: 'block', marginBottom: 4 }}>Name</label>
           <TextField
              name="name"
              size={isMobile ? "small" : isTablet ? "small" : "medium"}
              value={filters.name}
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                setFilters({ ...filters, name: value });
              }}
              placeholder="Enter Name"
              inputProps={{ maxLength: 50 }}
              fullWidth={isMobile}
            />

          </Box>

          <Box sx={{ width: isMobile ? '100%' : 'auto' }}>
            <label style={{ fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px', fontWeight: 500, display: 'block', marginBottom: 4 }}>Email</label>
            <TextField
              name="email"
              size={isMobile ? "small" : isTablet ? "small" : "medium"}
              value={filters.email}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, "");
                setFilters({ ...filters, email: value });
              }}
              error={filters.email && !emailValidation(filters.email)}
              helperText={filters.email && !emailValidation(filters.email) ? "Invalid email format" : ""}
              placeholder="Enter Email"
              inputProps={{ maxLength: 50 }}
              fullWidth={isMobile}
            />

          </Box>

          <Box sx={{ width: isMobile ? '100%' : 'auto' }}>

            <PhoneNumberField
              name="phoneNumber"
              size={isMobile ? "small" : isTablet ? "small" : "medium"}
             value={formatPhoneForDisplay(filters.phoneNumber)}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, '').substring(0, 10);
                setFilters({...filters, phoneNumber: digits});
              }}
              fullWidth={isMobile}
               placeholder="Enter Mobile No"
                labelStyle={{ fontSize: 14, fontWeight: 500,mb:0.5}}
                required={false}
            />
          </Box>

          <Box sx={{ width: isMobile ? '100%' : 'auto' }}>
            <label style={{ fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px', fontWeight: 500, display: 'block', marginBottom: 4 }}>
              City
            </label>
           <TextField
              name="city"
              size={isMobile ? "small" : isTablet ? "small" : "medium"}
              value={filters.city}
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                setFilters({ ...filters, city: value });
              }}
              placeholder="Enter City"
              inputProps={{ maxLength: 50 }}
              fullWidth={isMobile}
            />

          </Box>
          <Box sx={{mt:3}}>
          <Button
            onClick={handleSubmit}
            variant="outlined"
            size={isMobile ? "small" : isTablet ? "small" : "large"}
          >
            Search
          </Button>
          </Box>
           <Box sx={{mt:3}}>
          <Button
            onClick={handleReset}
            variant="outlined"
            size={isMobile ? "small" : isTablet ? "small" : "large"}
          >
            Reset
          </Button>
          </Box>
          {searchError && (
            <Box sx={{ width: '100%', mt: -1 }}>
              <Typography
                variant="caption"
                color="error"
                sx={{ display: 'block' }}
              >
                {searchError}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      </Box>
      {!hasSearched ? (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          border: '1px solid #e0e0e0'
        }}>
          <NoDataFound discription={"Please use the search filters above to fetch and display updated Rater Report data."} />
        </Box>
        ) : (
      <>

      <TableContainer
        component={Paper}
        sx={{ maxHeight: 1000, overflowY: 'auto' }}
      >
        <Table
          stickyHeader
          sx={{
            minWidth: isMobile ? '650px' : isTablet ? '800px' : '100%',
            '& .MuiTableCell-root': {
              fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
              padding: isMobile ? '8px' : isTablet ? '10px' : '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: isMobile ? '100px' : isTablet ? '150px' : '200px'
            },
            '& .MuiTableSortLabel-root': {
              fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px'
            }
          }}
          aria-label="policy table"
          size={isMobile ? "small" : isTablet ? "small" : "medium"}
        >
          <TableHead sx={{ backgroundColor: '#F6C21E' }}>
            <TableRow sx={{ backgroundColor: '#F6C21E' }}>
              {visibleColumns.name && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'name' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'name'}
                    direction={sortField === 'name' ? sortOrder : 'asc'}
                    onClick={() => handleSort('name')}
                  >
                    Name
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.id && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'id' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'id'}
                    direction={sortField === 'id' ? sortOrder : 'asc'}
                    onClick={() => handleSort('id')}
                  >
                    ID
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.agentName && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'agentName' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'agentName'}
                    direction={sortField === 'agentName' ? sortOrder : 'asc'}
                    onClick={() => handleSort('agentName')}
                  >
                    Agent Name
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.officeLocation && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'officeLocation' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'officeLocation'}
                    direction={sortField === 'officeLocation' ? sortOrder : 'asc'}
                    onClick={() => handleSort('officeLocation')}
                  >
                    Office Location
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.address && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'address' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'address'}
                    direction={sortField === 'address' ? sortOrder : 'asc'}
                    onClick={() => handleSort('address')}
                  >
                    Address
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.source && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'source' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'source'}
                    direction={sortField === 'source' ? sortOrder : 'asc'}
                    onClick={() => handleSort('source')}
                  >
                    Source
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.lastModified && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'lastModified' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'lastModified'}
                    direction={sortField === 'lastModified' ? sortOrder : 'asc'}
                    onClick={() => handleSort('lastModified')}
                  >
                    Last Modified
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.gethomeOwner && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'gethomeOwner' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'gethomeOwner'}
                    direction={sortField === 'gethomeOwner' ? sortOrder : 'asc'}
                    onClick={() => handleSort('gethomeOwner')}
                  >
                    Home Owner
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.occupation && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'occupation' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'occupation'}
                    direction={sortField === 'occupation' ? sortOrder : 'asc'}
                    onClick={() => handleSort('occupation')}
                  >
                    Occupation
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.zipCode && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'zipCode' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'zipCode'}
                    direction={sortField === 'zipCode' ? sortOrder : 'asc'}
                    onClick={() => handleSort('zipCode')}
                  >
                    Zip Code
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.city && (
                <TableCell  className="styled-table-heading" sortDirection={sortField === 'city' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'city'}
                    direction={sortField === 'city' ? sortOrder : 'asc'}
                    onClick={() => handleSort('city')}
                  >
                    City
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.email && (
                <TableCell className="styled-table-heading" sortDirection={sortField === 'email' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'email'}
                    direction={sortField === 'email' ? sortOrder : 'asc'}
                    onClick={() => handleSort('email')}
                  >
                    Email
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.phoneNumber && (
                <TableCell className="styled-table-heading" sortDirection={sortField === 'phoneNumber' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'phoneNumber'}
                    direction={sortField === 'phoneNumber' ? sortOrder : 'asc'}
                    onClick={() => handleSort('phoneNumber')}
                  >
                    Phone Number
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.quoteNumber && (
                <TableCell className="styled-table-heading" sortDirection={sortField === 'quoteNumber' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'quoteNumber'}
                    direction={sortField === 'quoteNumber' ? sortOrder : 'asc'}
                    onClick={() => handleSort('quoteNumber')}
                  >
                    Quote Number
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.boundStatus && (
                <TableCell className="styled-table-heading" sortDirection={sortField === 'boundStatus' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'boundStatus'}
                    direction={sortField === 'boundStatus' ? sortOrder : 'asc'}
                    onClick={() => handleSort('boundStatus')}
                  >
                    Bound Status
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.quoteDescription && (
                <TableCell className="styled-table-heading" sortDirection={sortField === 'quoteDescription' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'quoteDescription'}
                    direction={sortField === 'quoteDescription' ? sortOrder : 'asc'}
                    onClick={() => handleSort('quoteDescription')}
                  >
                    Quote Description
                  </TableSortLabel>
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          {!isFiltered ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={columnCount} align="center" sx={{ height: '200px' }}>
                  <Typography variant="h6" color="textSecondary">
                    Please apply filters and click search to view data
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : tableData.length === 0 ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={columnCount} align="center" sx={{ height: '200px' }}>
                  <Typography variant="h6" color="textSecondary">
                    <NoSearchResults />
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow className="styled-table-row" key={index}>
                  {visibleColumns.name && <TableCell>{row.name}</TableCell>}
                  {visibleColumns.id && <TableCell>{row.id}</TableCell>}
                  {visibleColumns.agentName && <TableCell>{row.agentName}</TableCell>}
                  {visibleColumns.officeLocation && <TableCell>{row.officeLocation}</TableCell>}
                  {visibleColumns.address && <TableCell>{row.address}</TableCell>}
                  {visibleColumns.source && <TableCell>{row.source}</TableCell>}
                  {visibleColumns.lastModified && <TableCell>{row.lastModified }</TableCell>}
                  {visibleColumns.gethomeOwner && <TableCell>{row.gethomeOwner}</TableCell>}
                  {visibleColumns.occupation && <TableCell>{row.occupation}</TableCell>}
                  {visibleColumns.zipCode && <TableCell>{row.zipCode}</TableCell>}
                  {visibleColumns.city && <TableCell>{row.city}</TableCell>}
                  {visibleColumns.email && <TableCell>{row.email}</TableCell>}
                  {visibleColumns.phoneNumber && (
                    <TableCell>{removePlusOne(row.phoneNumber)}</TableCell>
                  )}
                  {visibleColumns.quoteNumber && <TableCell>{row.quoteNumber}</TableCell>}
                  {visibleColumns.boundStatus && <TableCell>{row.boundStatus}</TableCell>}
                  {visibleColumns.quoteDescription && <TableCell>{row.quoteDescription}</TableCell>}
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {isFiltered && paginationData?.totalElements > 0 && (
        <Box sx={{
          width: '100%',
          padding: '16px 0',
          overflow: 'hidden',
          position: 'relative'
        }}>
          <Stack
            direction={isMobile ? "column" : "row"}
            justifyContent="flex-end"
            alignItems="center"
            flexWrap="wrap"
            spacing={2}
            sx={{
              width: '100%',
              overflow: 'hidden'
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{
                fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
                marginRight: '8px'
              }}>
                Rows per page:
              </Typography>
              <Select
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                size="small"
                sx={{
                  fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px',
                  minWidth: isMobile ? '60px' : isTablet ? '70px' : '80px',
                  height: isMobile ? '32px' : isTablet ? '36px' : '40px'
                }}
              >
                {[5, 10, 15, 25, 50, 100].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Pagination
              count={paginationData.totalPages}
              page={page + 1}
              onChange={(e, value) => handleChangePage(e, value - 1)}
              showFirstButton
              showLastButton
              siblingCount={isMobile ? 0 : isTablet ? 1 : 1}
              boundaryCount={isMobile ? 0 : isTablet ? 1 : 1}
              size={isMobile ? "small" : isTablet ? "small" : "medium"}
              sx={{
                '& .MuiPaginationItem-root': {
                  fontSize: isMobile ? '12px' : isTablet ? '13px' : '14px'
                }
              }}
            />
          </Stack>
        </Box>
      )}
       </>
      )}
    </Box>
  );
};

export default RaterReport;